import React, { useMemo } from 'react'
import { Single } from 'infrastructure/api'
import { packageListStringFromFeatures } from '../../../utility/utils'
import { Column } from 'shared/ui/Table/types'

interface ItemType {
  id: string | number
  name: string
  features: Single.PlatformFeature[]
}

export function useSchoolColumns(): Column<ItemType>[] {
  return useMemo(
    () => [
      {
        title: <strong>School ID</strong>,
        width: 75,
        rowContent({ id }) {
          return id
        },
      },
      {
        title: <strong>School Name</strong>,
        width: 125,
        rowContent({ name }) {
          return name
        },
      },
      {
        title: (
          <b>
            School feature packages
            <br />
            (bold features are locked by the district and can&apos;t be
            removed){' '}
          </b>
        ),
        width: 350,
        rowContent({ features }) {
          return packageListStringFromFeatures(features)
        },
      },
    ],
    [],
  )
}
